module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-512x512.10d7e33c6557ea178146b136a423dd03.png";